import { clearMerchantTokens } from 'api/axios'
import { clearActiveMerchants, destroyGroupCookies } from 'lib/merchant-group'
import { GetServerSidePropsContext, PreviewData } from 'next'
import { destroyCookie } from 'nookies'
import { ParsedUrlQuery } from 'querystring'

import { clearSearchHistory } from 'utils/searchHistory'
import { destroySessionCookie } from 'utils/sessionCookie'

// SC-11205: os cookies da sessão saem da raiz e dos prefixos da URL atual,
// inclusive a cópia que uma troca de conta em rota aninhada deixava em
// `path=/clientes` e sombreava o token novo.
export const destroySession = (
  ctx?: GetServerSidePropsContext<ParsedUrlQuery, PreviewData>
) => {
  destroySessionCookie(ctx, 'nextauth.uuid')
  destroySessionCookie(ctx, 'nextauth.token')
  destroySessionCookie(ctx, 'nextauth.user')
  destroySessionCookie(ctx, 'nextauth.email')
  destroySessionCookie(ctx, 'nextauth.installment_billings')
  destroySessionCookie(ctx, 'nextauth.status')
  destroySessionCookie(ctx, 'nextauth.user_logo_url')
  destroySessionCookie(ctx, 'nextauth.automatic_transfer')
  destroySessionCookie(ctx, 'nextauth.merchant_user_name')
  destroySessionCookie(ctx, 'nextauth.pro')
  destroySessionCookie(ctx, 'nextauth.role')
  destroySessionCookie(ctx, 'nextauth.subdomain')
  destroySessionCookie(ctx, 'nextauth.limit_days_for_payment')
  destroySessionCookie(ctx, 'nextauth.days_to_issue_billing')
  destroySessionCookie(ctx, 'nextauth.default_days_to_report')
  destroySessionCookie(ctx, 'nextauth.show_nps')
  destroySessionCookie(ctx, 'nextauth.merchant_user_uuid')
  destroySessionCookie(ctx, 'nextauth.shortcuts')
  destroySessionCookie(ctx, 'nextauth.nfse')
  destroySessionCookie(ctx, 'nextauth.document')
  destroySessionCookie(ctx, 'nextauth.portal_personalized')
  destroySessionCookie(ctx, 'nextauth.stage')
  destroySessionCookie(ctx, 'nextauth.free_tier')
  destroySessionCookie(ctx, 'nextauth.current_plan')
  destroySessionCookie(ctx, '6fa69047bb57a1a2837f271d59d45914')
  destroySessionCookie(ctx, 'nextauth.custom_invoice_domain')
  destroySessionCookie(ctx, 'nextauth.custom_portal_domain')
  destroySessionCookie(ctx, 'nextauth.merchant_email')
  // SC-10999: também são da empresa. Na troca de conta o login só regrava
  // estes cookies quando vêm preenchidos (cora_bank nem vem no payload), então
  // sem apagar aqui a empresa nova herdava o telefone, o estado da Cora e a
  // origem de aquisição da anterior.
  destroySessionCookie(ctx, 'nextauth.phone')
  destroySessionCookie(ctx, 'nextauth.cora_bank')
  destroySessionCookie(ctx, 'nextauth.cora_enabled')
  destroySessionCookie(ctx, 'nextauth.issue_billing_type')
  destroySessionCookie(ctx, 'nextauth.acquisition_source')
  destroySessionCookie(ctx, 'nextauth.acquisition_medium')
  destroySessionCookie(ctx, 'nextauth.acquisition_campaign')
  // SC-10999: sessão do grupo (multi-empresas) e login do seletor de contas.
  destroyGroupCookies(ctx)

  const nextAuthCookieOptions = { path: '/', secure: true }
  destroyCookie(ctx, '__Secure-next-auth.session-token', nextAuthCookieOptions)
  destroyCookie(ctx, '__Secure-next-auth.callback-url', nextAuthCookieOptions)
  destroyCookie(ctx, '__Host-next-auth.csrf-token', nextAuthCookieOptions)
  destroyCookie(ctx, 'next-auth.session-token', { path: '/' })
  destroyCookie(ctx, 'next-auth.callback-url', { path: '/' })
  destroyCookie(ctx, 'next-auth.csrf-token', { path: '/' })

  // Reset do widget SendPulse: o subscriberId fica no localStorage e e
  // "compartilhado" entre logins de contas diferentes no mesmo browser.
  // Sem limpar aqui, o proximo login herda o contato do SendPulse do
  // usuario anterior (variables.email antigas, deal vinculado a outro
  // merchant). Tambem zera as flags em memoria.
  if (typeof window !== 'undefined') {
    // SC-10999: histórico da busca global (nomes de clientes) não fica para o
    // próximo login no mesmo navegador
    clearSearchHistory()
    try {
      window.localStorage.removeItem('spSubscriberId')
    } catch {
      // best-effort: localStorage pode estar bloqueado
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const w = window as any
    w.__cbPulseIdentifiedEmail = null
    w.__cbPulseIdentifiedSid = null

    // Tokens das empresas do grupo e empresa ativa ficam só em memória.
    clearMerchantTokens()
    clearActiveMerchants()
  }
}
